import React from "react";
import PropTypes from "prop-types";

const HighchartsReact = window.HighchartsReact;
import seychellesMapData from "../data/seychelles";

const SeychellesMap = ({ highcharts, selectedCountry, selectCountry, tariffValueColor }) => {

  const mapOptions = {
    chart: {
      height: 200,
      width: 200,
      style: {
        fontFamily: "'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif"
      },
      borderColor: selectedCountry === "sc" ? "#c84646" : "#bdc2bf",
      borderWidth: 3
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false
    },
    title: {
      text: ""
    },
    legend: {
      enabled: false
    },
    series: [{
      mapData: seychellesMapData,
      data: [],
      nullColor: tariffValueColor,
      borderColor: "#4cb563",
      borderWidth: 0.1,
    }]
  };

  return (
    <div className="seychelles-wrapper">
      <div className="title" style={{ color: tariffValueColor }}>Seychelles</div>
      <div onClick={() => selectCountry("sc")} >
        <HighchartsReact
          highcharts={highcharts}
          constructorType={"mapChart"}
          options={mapOptions}
          key={selectedCountry}
        />
      </div>
    </div>
  );
};

export default SeychellesMap;

SeychellesMap.propTypes = {
  highcharts: PropTypes.shape({
    charts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  selectedCountry: PropTypes.string.isRequired,
  selectCountry: PropTypes.func.isRequired,
  tariffValueColor: PropTypes.string.isRequired,
};
